import Vue from 'vue';
var TokenKey = 'token';
var UserInfoKey = 'userInfo';
var RealNameInfoKey = 'realNameInfo';
var TradePwd = 'tradePwd';
var ThemeColor = 'themeColor';
var FYWalletInfoKey = 'fyWalletInfo';
var ActivityPopup = 'activityPopup';
var FYAuthResultKey = 'fyAuthResult';
var SelectBankKey = 'selectBank';
var NotRealNameDialog = 'notRealNameDialog';
var MarketHistoryLength = 'marketHistoryLength';
var OpenIdKey = 'openId';
var GameTokenKey = 'gameToken';
var SkillListKey = 'skillList';
var CheckedSkillKey = 'checkedSkill'; // token

export function getToken() {
  return Vue.ls.get(TokenKey);
}
export function setToken(token) {
  return Vue.ls.set(TokenKey, token, 7 * 24 * 60 * 60 * 1000);
}
export function removeToken() {
  return Vue.ls.remove(TokenKey);
} // 用户信息

export function lsGetUserInfo() {
  return Vue.ls.get(UserInfoKey);
}
export function lsSetUserInfo(data) {
  return Vue.ls.set(UserInfoKey, data);
}
export function lsRemoveUserInfo() {
  return Vue.ls.remove(UserInfoKey);
} // 实名信息

export function lsGetRealNameInfo() {
  return Vue.ls.get(RealNameInfoKey);
}
export function lsSetRealNameInfo(data) {
  return Vue.ls.set(RealNameInfoKey, data);
}
export function lsRemoveRealNameInfo() {
  return Vue.ls.remove(RealNameInfoKey);
} // 交易密码

export function lsGetTradePwd() {
  return Vue.ls.get(TradePwd);
}
export function lsSetTradePwd(data) {
  return Vue.ls.set(TradePwd, data);
}
export function lsRemoveTradePwd() {
  return Vue.ls.remove(TradePwd);
} // 深浅色主题

export function setThemeColor(data) {
  console.log(ThemeColor, data);
  return Vue.ls.set(ThemeColor, data);
}
export function getThemeColor() {
  return Vue.ls.get(ThemeColor);
} // 钱包状态

export function lsSetFYWalletInfo(data) {
  return Vue.ls.set(FYWalletInfoKey, data);
}
export function lsGetFYWalletInfo() {
  return Vue.ls.get(FYWalletInfoKey);
}
export function lsRemoveFYWalletInfo() {
  return Vue.ls.remove(FYWalletInfoKey);
} // 活动弹窗

export function lsGetActivityPopup() {
  return Vue.ls.get(ActivityPopup);
}
export function lsSeActivityPopup(data) {
  return Vue.ls.set(ActivityPopup, data, 12 * 60 * 60 * 1000);
}
export function lsRemoveActivityPopup() {
  return Vue.ls.remove(ActivityPopup);
} // 富友钱包身份认证结果

export function lsGetFYAuthResult() {
  return Vue.ls.get(FYAuthResultKey);
}
export function lsSetFYAuthResult(data) {
  return Vue.ls.set(FYAuthResultKey, data);
}
export function lsRemoveFYAuthResult() {
  return Vue.ls.remove(FYAuthResultKey);
} // 选择银行

export function lsGetSelectBank() {
  return Vue.ls.get(SelectBankKey);
}
export function lsSetSelectBank(data) {
  return Vue.ls.set(SelectBankKey, data);
}
export function lsRemoveSelectBank() {
  return Vue.ls.remove(SelectBankKey);
} // 未实名弹窗

export function lsGetNotRealNameDialog() {
  return Vue.ls.get(NotRealNameDialog);
}
export function lsSetNotRealNameDialog(data) {
  return Vue.ls.set(NotRealNameDialog, data);
} // 二级市场 路由push history 长度记录

export function lsSetMarketHistoryLength(data) {
  return Vue.ls.set(MarketHistoryLength, data);
}
export function lsRemoveMarketHistoryLength() {
  return Vue.ls.remove(MarketHistoryLength);
}
export function lsGetMarketHistoryLength() {
  return Vue.ls.get(MarketHistoryLength);
} // 游戏openId

export function lsGetOpenId() {
  return Vue.ls.get(OpenIdKey);
}
export function lsSetOpenId(data) {
  return Vue.ls.set(OpenIdKey, data);
}
export function lsRemoveOpenId() {
  return Vue.ls.remove(OpenIdKey);
} // 游戏token

export function lsGetGameToken() {
  return Vue.ls.get(GameTokenKey);
}
export function lsSetGameToken(data) {
  return Vue.ls.set(GameTokenKey, data);
}
export function lsRemoveGameToken() {
  return Vue.ls.remove(GameTokenKey);
} // 技能卡列表

export function lsGetSkillList() {
  return Vue.ls.get(SkillListKey);
}
export function lsSetSkillList(data) {
  return Vue.ls.set(SkillListKey, data);
}
export function lsRemoveSkillList() {
  return Vue.ls.remove(SkillListKey);
} // 已装备的技能列表

export function lsGetCheckedSkill() {
  return Vue.ls.get(CheckedSkillKey);
}
export function lsSetCheckedSkill(data) {
  return Vue.ls.set(CheckedSkillKey, data);
}
export function lsRemoveCheckedSkill() {
  return Vue.ls.remove(CheckedSkillKey);
}
export default {
  getToken: getToken,
  setToken: setToken,
  removeToken: removeToken,
  lsGetUserInfo: lsGetUserInfo,
  lsSetUserInfo: lsSetUserInfo,
  lsRemoveUserInfo: lsRemoveUserInfo,
  lsGetRealNameInfo: lsGetRealNameInfo,
  lsSetRealNameInfo: lsSetRealNameInfo,
  lsRemoveRealNameInfo: lsRemoveRealNameInfo,
  lsGetTradePwd: lsGetTradePwd,
  lsSetTradePwd: lsSetTradePwd,
  lsRemoveTradePwd: lsRemoveTradePwd,
  setThemeColor: setThemeColor,
  getThemeColor: getThemeColor,
  lsSetFYWalletInfo: lsSetFYWalletInfo,
  lsGetFYWalletInfo: lsGetFYWalletInfo,
  lsRemoveFYWalletInfo: lsRemoveFYWalletInfo,
  lsGetActivityPopup: lsGetActivityPopup,
  lsSeActivityPopup: lsSeActivityPopup,
  lsRemoveActivityPopup: lsRemoveActivityPopup,
  lsGetFYAuthResult: lsGetFYAuthResult,
  lsSetFYAuthResult: lsSetFYAuthResult,
  lsRemoveFYAuthResult: lsRemoveFYAuthResult,
  lsGetSelectBank: lsGetSelectBank,
  lsSetSelectBank: lsSetSelectBank,
  lsRemoveSelectBank: lsRemoveSelectBank,
  lsGetNotRealNameDialog: lsGetNotRealNameDialog,
  lsSetNotRealNameDialog: lsSetNotRealNameDialog,
  lsSetMarketHistoryLength: lsSetMarketHistoryLength,
  lsRemoveMarketHistoryLength: lsRemoveMarketHistoryLength,
  lsGetMarketHistoryLength: lsGetMarketHistoryLength,
  lsGetOpenId: lsGetOpenId,
  lsSetOpenId: lsSetOpenId,
  lsRemoveOpenId: lsRemoveOpenId,
  lsGetGameToken: lsGetGameToken,
  lsSetGameToken: lsSetGameToken,
  lsRemoveGameToken: lsRemoveGameToken,
  lsGetSkillList: lsGetSkillList,
  lsSetSkillList: lsSetSkillList,
  lsRemoveSkillList: lsRemoveSkillList,
  lsGetCheckedSkill: lsGetCheckedSkill,
  lsSetCheckedSkill: lsSetCheckedSkill,
  lsRemoveCheckedSkill: lsRemoveCheckedSkill
};